var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9728 1.98438C17.9152 5.34879 18.9378 9.16524 18.9378 13.0501C18.9378 16.935 17.9152 20.7515 15.9728 24.1159M11.1038 4.41884C12.6189 7.04308 13.4166 10.0199 13.4166 13.0501C13.4166 16.0803 12.6189 19.0572 11.1038 21.6814M6.45621 6.65412C7.55175 8.57184 8.1285 10.7472 8.1285 12.9616C8.1285 15.176 7.55175 17.3514 6.45621 19.2691M1.80859 9.06645C2.59814 10.2614 3.01672 11.6416 3.01672 13.0501C3.01672 14.4586 2.59814 15.8389 1.80859 17.0338",
    stroke: "white",
    strokeWidth: 2.65578,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardWifi);
export default __webpack_public_path__ + "static/media/card-wifi.ed44078dad76a3124c8d7e99bb913ff9.svg";
export { ForwardRef as ReactComponent };